module.exports = __webpack_public_path__ + "static/media/check_white.b98d1141.svg";